import parseDate from 'date-fns/parse'

/**
 * @typedef {Object} ReleaseData
 * @property {(number|string)} version - X.X will be numbers, X.X.X will be strings (due to YML)
 * @property {number}          [build] - optional build number for the release binary
 * @property {string}          release-date - release date as DD-MM-YYYY
 * @property {string}          requirements - human-readable as "{OS name} {OS version name} ({ OS version number}) or newer"
 * @property {string}          guid - unique release identifier
 * @property {string}          url
 */

/**
 * Get an array with releases, reverse-chron
 * @returns {Promise<?ReleaseData[]>}
 */
async function macReleases() {
  const response = await fetch('/api/releases/mac.json')
  if (!response.ok) throw new Error('Failed to request /api/releases/mac.json')

  /** @type {ReleaseData[]} */
  const releases = await response.json()
  // Transform data for JS usage
  releases.forEach((release) => {
    // release versions might be numbers, make all strings
    release.version = release.version.toString()
    // transform to Date using UTC to avoid timezone discrepancies
    const parsedDate = parseDate(release['release-date'], 'yyyy-MM-dd', new Date())
    release['release-date'] = new Date(Date.UTC(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate()))
  })
  return releases
}

/**
 * Get the most recent Mac release as of a date
 * Uses UTC dates to ensure consistent results across all timezones
 * @param {(number|Date)} timestampOrDate
 * @returns {Promise<?ReleaseData>}
 */
async function latestMacReleaseOnDate(timestampOrDate) {
  // Convert input to UTC date for consistent comparison
  let expirationDate
  if (typeof timestampOrDate === 'number') {
    const tempDate = new Date(timestampOrDate * 1000)
    expirationDate = new Date(Date.UTC(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate()))
  } else {
    expirationDate = new Date(
      Date.UTC(timestampOrDate.getUTCFullYear(), timestampOrDate.getUTCMonth(), timestampOrDate.getUTCDate())
    )
  }

  const releases = await macReleases()

  let latestRelease = null
  releases.forEach((release) => {
    if (release['release-date'] > expirationDate) return

    if (!latestRelease || release['release-date'] > latestRelease['release-date']) {
      latestRelease = release
    }
  })
  return latestRelease
}

export { macReleases, latestMacReleaseOnDate }
